module.exports = __webpack_public_path__ + "media/images/pic/anime/team-ac8af695a99e0b5e47e25cb32adb6c10.svg";